"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var memoize_one_1 = require("memoize-one");
var metrics_engine_1 = require("@tableau/metrics-engine");
var TimeSeriesInteractiveLayer = /** @class */ (function (_super) {
    __extends(TimeSeriesInteractiveLayer, _super);
    function TimeSeriesInteractiveLayer(props) {
        var _this = _super.call(this, props) || this;
        _this.scrubInProgress = false;
        _this.handleMouseEnter = function () {
            _this.scrubInProgress = true;
        };
        _this.handleMouseLeave = function () {
            _this.scrubInProgress = false;
            _this.setState({ tooltipText: undefined });
        };
        _this.handleMouseMove = function (e) {
            _this.scrubInProgress = true;
            _this.updateForPointerLocation(e.currentTarget, e.clientX);
        };
        _this.handleTouchMove = function (e) {
            _this.updateForPointerLocation(e.currentTarget, e.touches.item(0).clientX);
        };
        _this.updateForPointerLocation = function (target, clientX) {
            var rect = target.getBoundingClientRect();
            var xOffset = rect.left;
            var x = Math.round(clientX - xOffset);
            var dataPointIndex = _this.hitMaps.mapOfPixelXCoordsToIndexInDataPoints[x];
            _this.updateDotAndLineLocationForDataPointIndex(dataPointIndex);
        };
        _this.updateDotAndLineLocationForDataPointIndex = function (dataPointIndex) {
            var dataPoint = _this.props.data[dataPointIndex];
            if (dataPoint) {
                _this.props.onDataPointActivated(dataPoint);
                var timestamp = _this.props.timestampAccessor && _this.props.timestampAccessor(dataPoint);
                var tooltipText = (_this.scrubInProgress && timestamp) ? _this.props.tooltipFormatter(timestamp) : undefined;
                _this.setState({ dataPointIndex: dataPointIndex, tooltipText: tooltipText });
            }
        };
        /**
         * This takes the size of the space the container View occupies,
         * then subtracts padding giving the data area size.  Then it builds the two
         * hit maps used during gesture handling.
         */
        _this.generateHitMaps = function () {
            return _this.generateHitMapsMemoized(_this.props.size, _this.props.padding, _this.props.domain, _this.props.data);
        };
        // tslint:disable-next-line: typedef
        _this.generateHitMapsMemoized = memoize_one_1.default(function (size, padding, domain, data) {
            var finalWidth = size.width - (padding.left + padding.right);
            var finalHeight = size.height - (padding.top + padding.bottom);
            return metrics_engine_1.calculateHitMaps(data, finalWidth, finalHeight, domain.x, domain.y, padding.right);
        });
        _this.hitMaps = _this.generateHitMaps();
        _this.state = { dataPointIndex: _this.props.data.length - 1 };
        return _this;
    }
    TimeSeriesInteractiveLayer.prototype.render = function () {
        var actualArea = {
            top: this.props.padding.top,
            left: this.props.padding.left,
            height: this.props.size.height - (this.props.padding.top + this.props.padding.bottom),
            width: this.props.size.width - this.props.padding.left,
        };
        this.hitMaps = this.generateHitMaps();
        var dataPointIndex = this.state.dataPointIndex < this.hitMaps.mapOfDataPointIndexToCoords.length
            ? this.state.dataPointIndex
            : this.hitMaps.mapOfDataPointIndexToCoords.length - 1;
        var _a = this.hitMaps.mapOfDataPointIndexToCoords[dataPointIndex], x = _a.x, y = _a.y;
        return (React.createElement("div", { "data-tb-test-id": 'time-series-interactive-layer', style: __assign({ position: 'absolute' }, actualArea), onMouseMove: this.handleMouseMove, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onTouchStart: this.handleMouseEnter, onTouchEnd: this.handleMouseLeave, onTouchMove: this.handleTouchMove },
            React.createElement("div", { style: __assign({ position: 'relative', height: actualArea.height + TOOLTIP_OFFSET, top: -TOOLTIP_OFFSET, transform: "translateX(" + (x - 1) + "px)" }, indicatorLineStyle) }),
            React.createElement("div", { style: __assign({ position: 'relative', transform: "translateX(" + x + "px)", top: -actualArea.top }, tooltipStyle) }, this.state.tooltipText),
            React.createElement("div", { style: __assign({ position: 'relative', transform: "translateX(" + x + "px) translateY(" + y + "px)" }, dotStyle) })));
    };
    return TimeSeriesInteractiveLayer;
}(React.PureComponent));
exports.TimeSeriesInteractiveLayer = TimeSeriesInteractiveLayer;
var VERTICAL_BAR_TOOLTIP_CONTAINER_WIDTH = 160;
var dotStyle = {
    backgroundColor: metrics_engine_1.MetricBlue,
    position: 'absolute',
    left: -7,
    top: -7,
    height: 14,
    width: 14,
    borderRadius: 14,
    border: '1px',
    borderColor: 'white',
    borderStyle: 'solid',
    pointerEvents: 'none',
    boxSizing: 'border-box',
};
// We set both the background color and the left border style / color to support browser zoom.
// Background of 1px will allow the width to grow when the user zooms in.
// Left border width of 'thin' will allow the line to remain visible when the user zooms out.
var indicatorLineStyle = {
    width: 1,
    borderLeftStyle: 'solid',
    borderLeftWidth: 'thin',
    borderLeftColor: metrics_engine_1.MetricBlue,
    backgroundColor: metrics_engine_1.MetricBlue,
    pointerEvents: 'none'
};
var TOOLTIP_OFFSET = 20;
var tooltipStyle = {
    position: 'absolute',
    left: -VERTICAL_BAR_TOOLTIP_CONTAINER_WIDTH / 2,
    width: VERTICAL_BAR_TOOLTIP_CONTAINER_WIDTH,
    marginTop: 10,
    textAlign: 'center',
    color: metrics_engine_1.MetricBlue,
    fontSize: 14,
    fontFamily: 'Benton Sans',
};
//# sourceMappingURL=TimeSeriesInteractiveLayer.js.map